import { useState } from "react";
import { Card, CardHeader, CardBody, Container, Row, Col } from "reactstrap";

import TeacherUsage from "./Screens/TeacherUsage";
import StudentUsage from "./Screens/StudentUsage";
import MapData from "../../components/maps/MapData";
import Header from "../../components/Headers/Header";
import DistrictWithMap from "../../components/maps/DistrictWithMap";

import { ITypeForTopTen } from "../../types";
import TopTen from "../../components/TopTen/TopTen";
import TeacherTopTen from "./Screens/TeacherTopTen";
import StudentTopTen from "./Screens/StudentTopTen";
import useOverViewStudent from "./Hooks/useOverViewStudent";
import { CustomModal } from "../../components/Modals/CustomModal";
import WeeksDropDown from "../../components/DropDown/WeeksDropDown";
import EAdhigamInfoSection from "../../components/EAdhigamInfo/EAdhigamInfoSection";
import StatsMoreDetails from "../../components/StatsMoreDeatils/StatsMoreDetails";
import DropDown from "../../components/DropDown/DropDown";

export default function StateOfficialIndex() {

  const {
    averageCriteria,
    setAverageCriteria,
    e_AdhigamStudentData,
    district_E_AdhigamStudentData,
    block_E_AdhigamStudentData,
    isAdhigamStudentLoading,
    stateMapData,
    districtMapData,
    isMapLoading,
    OverAllStudent,
    OverAllDistrictStudent,
    OverAllBlockStudent,
    isOverAllStudentLoading,
    selectedDistrict,
    setSelectedDistrict,
    selectedBlock,
    setSelectedBlock,
    isOverAllTeacherLoading,
    OverAllTeacher,
    OverAllDistrictTeacher,
    OverAllBlockTeacher,
    selectedWeekNo,
    setSelectedWeekNo,
    filter,
    updateYearSelection
  } = useOverViewStudent();


  const [isOpenTopTenModal, setIsOpenTopTenModal] = useState<boolean>(false)
  const [isOpenStatsDetail, setIsOpenStatsDetail] = useState<boolean>(false)
  const [type, setType] = useState<ITypeForTopTen>()


  const titleLabel = {
    app_usage: "wise Total PAL Usage by ",
    assessments: "wise Total PAL Homework by ",
    total_usage: "wise Total PAL Usage by ",
    time_videos: "Time on Videos",
    remedial: "wise Total PAL Remedial Tests Attempted by ",
    assignments: "wise Total PAL Homework by ",
    total_pall_usage_in_min_teacher: "Total app usage",
    total_assessments_by_teacher: "Homework /Assignments",
    Total_queries_solved: "Queries solved",
    Total_queries_raised: "Queries raised",
    Avg_Remedial: "Remedial test",
    Total_Assignments: "Homework / Assignments",
    Total_time_videos: "Time on videos",
    avgStudentUsage: "App usage",
    timeSpentOnStudentMonitoring: "Students Monitoring"
  };



  return (
    <>
      <Header />
      <Container className="mt-3 mt--9" fluid>
        <Card className="shadow">
          <CardHeader className="bg-transparent">
            <Row className="align-items-center d-flex justify-content-between">
              <div>
                <h3 className="mb-0 text-muted">
                  <i className="fas fa-clipboard-list mr-1"></i>Overall Statistics
                </h3>
              </div>
              <div></div>
              <div className="d-flex">
                {/* {!!selectedDistrict ? (
                  <button
                    className="rounded btn-outline-primary"
                    onClick={() => setSelectedDistrict("")}
                  >
                    <ArrowLeft /> Back{" "}
                  </button>
                ) : (
                  <></>
                )} */}
                {/* <DropDown
               type="Criteria"
               selectedValue={averageCriteria=="active" ? 2 : 1}
               options={[{id:1,name:"Total Users"},{id:2,name:"Active Users"}]}
               onChange={(e)=>{
                e.id == 1 ?
                setAverageCriteria("total") :setAverageCriteria('active')
               }}
               /> */}
                <div>
                  <WeeksDropDown
                    selectedValue={selectedWeekNo}
                    direction="right"
                    type="Week No. "
                    isDisabled={!!selectedDistrict}
                    onChange={(value) => {
                      setSelectedWeekNo(value.id)
                    }}
                  />
                  <DropDown
                    direction="left"
                    type="Year"
                    selectedValue={filter.year}
                    options={[
                      { id: 2023, name: "2023" },
                      { id: 2024, name: "2024" },
                      { id: 2025, name: "2025" },
                      { id: 2026, name: "2026" },
                    ]}
                    onChange={(e) => updateYearSelection(e.id)}
                  />
                  {!!selectedDistrict ? <>
                    <p className="text-xs text-muted p-1">Week can be selected from the state map</p></> : <></>}

                </div>
                {/* <ButtonGroup
                  size="sm"
                >
                  <Button
                    className={`${averageCriteria === "total" ? "text-primary" : ""}`}
                    onClick={() => setAverageCriteria("total")}
                  >
                    Total User
                  </Button>
                  <Button
                    className={`${averageCriteria === "active" ? "text-primary" : ""}`}
                    onClick={() => setAverageCriteria("active")}
                  >
                    Active User
                  </Button>
                </ButtonGroup> */}

              </div>
            </Row>
          </CardHeader>
          <CardBody>
            {/* E-Adhigam Definition */}
            <EAdhigamInfoSection />
            {!selectedDistrict ? (
              <>
                {/* <CardBody> */}
                <div className="row">
                  <div className="col">
                    <TeacherUsage
                      stats={OverAllTeacher}
                      isLoading={isOverAllTeacherLoading}
                      averageCriteria={averageCriteria}
                      handleClick={(e) => {
                        setType(e)
                        setIsOpenStatsDetail(true)
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <MapData
                      data={stateMapData}
                      isLoading={isMapLoading}
                      setSelcetdistrict={(district) => {
                        console.log("district is : in the index ", district)
                        setSelectedDistrict(district)
                        setSelectedBlock("")
                      }}
                    />
                  </div>
                  <div className="col">
                    <StudentUsage
                      stats={OverAllStudent}
                      isLoading={isOverAllStudentLoading}
                      district={selectedDistrict}
                      isAdhigamLoading={isAdhigamStudentLoading}
                      EAdhigamData={e_AdhigamStudentData}
                      averageCriteria={averageCriteria}
                      handleClick={(e) => {
                        setType(e)
                        setIsOpenStatsDetail(true)
                      }}
                    />
                  </div>
                </div>

                {/* <OtherStats
                  teacherStats={OverAllTeacher}
                  isLoadingTeacher={isOverAllTeacherLoading}
                  studentStats={OverAllStudent}
                  isLoadingStudent={isOverAllStudentLoading}
                  averageCriteria={averageCriteria}
                  handleClick={(e) => {
                    setType(e)
                    setIsOpenStatsDetail(true)
                  }} /> */}
                <Row>
                  <Col>
                    <TeacherTopTen
                      stats={OverAllTeacher}
                      isLoading={isOverAllTeacherLoading}
                      district={selectedDistrict}
                      block={selectedBlock}
                      week_no={selectedWeekNo}
                      handleModalCLick={(e) => {
                        setType(e)
                        setIsOpenTopTenModal(true)
                      }}
                    /></Col>
                  <Col>
                    <StudentTopTen
                      handleModalCLick={(e) => {
                        setType(e)
                        setIsOpenTopTenModal(true)
                      }}
                      stats={OverAllStudent}
                      isLoading={isOverAllStudentLoading}
                      district={selectedDistrict}
                      block={selectedBlock}
                      week_no={selectedWeekNo}
                    />
                  </Col>
                </Row>
                <hr />
              </>
            ) : (
              <>
                <div className="row">
                  <div className="col">
                    <TeacherUsage
                      stats={
                        !!selectedBlock
                          ? OverAllBlockTeacher
                          : OverAllDistrictTeacher
                      }
                      isLoading={isOverAllTeacherLoading}
                      averageCriteria={averageCriteria}
                      handleClick={(e) => {
                        setType(e)
                        setIsOpenStatsDetail(true)
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <DistrictWithMap
                      isLoading={isMapLoading}
                      handleBack={() => {
                        setSelectedDistrict("")
                        setSelectedBlock("")
                      }}
                      selectedDistrict={selectedDistrict}
                      districtMapData={districtMapData}
                      handleBlock={(e) => setSelectedBlock(e)}
                    />
                  </div>

                  <div className="col">
                    <StudentUsage
                      stats={
                        !!selectedBlock
                          ? OverAllBlockStudent
                          : OverAllDistrictStudent
                      }
                      EAdhigamData={
                        !!selectedBlock
                          ? block_E_AdhigamStudentData
                          : district_E_AdhigamStudentData
                      }
                      isLoading={isOverAllStudentLoading}
                      isAdhigamLoading={isAdhigamStudentLoading}
                      district={selectedDistrict}
                      block={selectedBlock}
                      averageCriteria={averageCriteria}
                      handleClick={(e) => {
                        setType(e)
                        setIsOpenStatsDetail(true)
                      }}
                    />
                  </div>
                </div>
                <div>
                  {/* <OtherStats
                    teacherStats={
                      !!selectedBlock
                        ? OverAllBlockTeacher
                        : OverAllDistrictTeacher
                    }
                    isLoadingTeacher={isOverAllTeacherLoading}
                    studentStats={
                      !!selectedBlock
                        ? OverAllBlockStudent
                        : OverAllDistrictStudent
                    }
                    isLoadingStudent={isOverAllStudentLoading}
                    averageCriteria={averageCriteria}
                    handleClick={(e) => {
                      setType(e)
                      setIsOpenStatsDetail(true)
                    }} /> */}
                  <Row>
                    <Col>
                      <TeacherTopTen
                        stats={OverAllTeacher}
                        isLoading={isOverAllTeacherLoading}
                        district={selectedDistrict}
                        block={selectedBlock}
                        week_no={selectedWeekNo}
                        handleModalCLick={(e) => {
                          setType(e)
                          setIsOpenTopTenModal(true)
                        }}
                      />
                    </Col>
                    <Col>
                      <StudentTopTen
                        stats={
                          !!selectedBlock
                            ? OverAllBlockStudent
                            : OverAllDistrictStudent
                        }
                        isLoading={isOverAllStudentLoading}
                        district={selectedDistrict}
                        block={selectedBlock}
                        week_no={selectedWeekNo}
                        handleModalCLick={(e) => {
                          setType(e)
                          setIsOpenTopTenModal(true)
                        }}
                      />
                    </Col>
                  </Row>
                </div>
                {/* </CardBody> */}
              </>
            )}
          </CardBody>
        </Card>
      </Container>
      {isOpenTopTenModal && <CustomModal title={`Top 10 ${type?.for}s - ${titleLabel[type?.type]} data`} size='fullscreen' onClose={() => setIsOpenTopTenModal(false)} body={<TopTen type={type} district={selectedDistrict ? selectedDistrict : "all"} block={selectedBlock ? selectedBlock : "all"} week_no={selectedWeekNo} />} />
      }
      {isOpenStatsDetail && <CustomModal title={`${selectedDistrict ? `Block -` : `District -`} ${titleLabel[type?.type]} ${type?.for}s`} size="lg" onClose={() => setIsOpenStatsDetail(false)} body={<StatsMoreDetails type={type} district={selectedDistrict ? selectedDistrict : "all"} block={selectedBlock ? selectedBlock : "all"} week_no={selectedWeekNo} />} />
      }</>);
}
